import { Injectable } from '@angular/core';
// import Rx from 'rxjs/Rx';
import * as Rx from 'rxjs';
// import { Observable } from 'rxjs';
import { GlobalFunctionsService } from './global-functions.service';

    import { fromEvent } from 'rxjs';
    import { throttleTime } from 'rxjs/operators';

@Injectable()
export class IdleService {

  constructor(public gfunc: GlobalFunctionsService) {
    // document.addEventListener("click", this.resetTimer, false);
    // pre tsaVM
    // let documentStream = Rx.Observable.fromEvent(document, 'click').throttleTime(1000).subscribe(() => this.resetCount());

    // let documentStream =  Observable.of.fromEvent(document, 'click').throttleTime(1000).subscribe(() => this.resetCount());

    // Mew Code Foud
    // @ :: https://stackoverflow.com/questions/52137092/angular-6-throttletime-doesnt-exist-in-rx-js
    let documentStream = fromEvent(document, 'click')
                   .pipe(throttleTime(1000))
                   .subscribe(x => this.resetCount());

    // import { fromEvent } from 'rxjs';
    // import { throttleTime } from 'rxjs/operators';
    
    // subscription = fromEvent(document, 'click')
    //                .pipe(throttleTime(1000))
    //                .subscribe(x => console.log(x));


  }

  private timeoutID: any;
  private seconds: number = 0;
  private timer_is_on = false;
  private idleTime = 0;

  init(idleTimeTrigger){
    this.idleTime = idleTimeTrigger;
    this.startCount();
  }


  incrementCount() {
    if (this.seconds >= this.idleTime) {
      this.stopCount();
      this.goInactive();
    }
    else {
      this.seconds = this.seconds + 1;
      this.timeoutID = setTimeout(() => { this.incrementCount(); }, 1000);
      // console.log('seconds: ' + this.seconds);
    }
  }

  startCount() {
    if (!this.timer_is_on) {
      this.timer_is_on = true;
      this.incrementCount();
    }
  }

  resetCount() {
    clearTimeout(this.timeoutID);
    this.seconds = 0;
    this.timer_is_on = false;
    this.startCount();
  }

  stopCount() {
    clearTimeout(this.timeoutID);
    this.timer_is_on = false;
  }

  goInactive() {
   // alert('Please press Cntrl + Shift + refresh (hard refresh) your browser, then login again.');
    // console.warn('goInactive');
    // console.warn('logout - goodbye :)');
  
  
    // Turned off to stop loggin me ou tall the time in development - August 2023 ( you can comment line below to switch off autimatic logout)
// this.gfunc.logout();
               // this.gfunc.login();


    // this.logout();

  }

  getSeconds(){
    return this.seconds;
  }


}